/**
 * @generated SignedSource<<297a191e5257aab74cc3833dadd29e38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateUserPlatformSessionLastPingInput = {
  userPlatformSessionId: string;
};
export type TimeOnPlatformUpdateMutation$variables = {
  input: UpdateUserPlatformSessionLastPingInput;
};
export type TimeOnPlatformUpdateMutation$data = {
  readonly updateUserPlatformSessionLastPing: {
    readonly userPlatformSessionNode: {
      readonly id: string;
    } | null | undefined;
  };
};
export type TimeOnPlatformUpdateMutation = {
  response: TimeOnPlatformUpdateMutation$data;
  variables: TimeOnPlatformUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateUserPlatformSessionLastPingPayload",
    "kind": "LinkedField",
    "name": "updateUserPlatformSessionLastPing",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserPlatformSessionNode",
        "kind": "LinkedField",
        "name": "userPlatformSessionNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TimeOnPlatformUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TimeOnPlatformUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6b165447bf6203cbebfea5b8f9efda58",
    "id": null,
    "metadata": {},
    "name": "TimeOnPlatformUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation TimeOnPlatformUpdateMutation(\n  $input: UpdateUserPlatformSessionLastPingInput!\n) {\n  updateUserPlatformSessionLastPing(input: $input) {\n    userPlatformSessionNode {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "27cf6ede80b762b4cef922edf32b594d";

export default node;
